import * as Blockly from 'blockly/core';
import { defineBlock } from '@/(routers)/boards/editor/block/blockRegistry';
import { darken } from '@/(routers)/boards/editor/block/blockTheme';
import { CATEGORIES } from '@/(routers)/boards/editor/block/definitions/categories';
import { FieldStyledLabel } from '@/(routers)/boards/editor/block/definitions/fields/fieldStyledLabel';

defineBlock({
    type: 'delay',
    colour: darken(CATEGORIES.control.color),
    tooltip: '指定した時間だけ待ちます',
    movable: true,
    deletable: true,
    previousStatement: true,
    nextStatement: true,
    inputs: [
        {
            kind: 'dummy',
            fields: [
                { type: 'image', icon: { src: '/images/block/delay.svg', size: 65 } },
                {
                    type: 'field',
                    name: 'DELAY_LABEL',
                    instance: () => new FieldStyledLabel('DELAY', { fontSize: 12, fontWeight: 'bold' }),
                },
                { type: 'label', text: ' ' },
            ],
        },
        {
            kind: 'value',
            name: 'DURATION',
            check: 'Number',
            shadow: { type: 'number', fields: { NUM: 1000 } },
        },
        {
            kind: 'dummy',
            fields: [
                {
                    type: 'dropdown',
                    name: 'UNIT',
                    options: [
                        { value: 'ms', label: 'ミリ秒', tooltip: '[1/1,000 秒]' },
                        { value: 's', label: '秒', tooltip: '[1 秒]' },
                        { value: 'us', label: 'マイクロ秒', tooltip: '[1/1,000,000 秒]' },
                    ],
                },
                { type: 'label', text: 'だけ待つ ' },
            ],
        },
    ],
    onInit(this: Blockly.Block) {
        const updateLabel = (unit: string) => {
            const label = unit === 'us' ? 'DELAY MICROSECONDS' : 'DELAY';
            this.getField('DELAY_LABEL')?.setValue(label);
        };

        const unitField = this.getField('UNIT');
        unitField?.setValidator((value: string) => {
            updateLabel(value);
            return value;
        });

        updateLabel(this.getFieldValue('UNIT') ?? 'ms');
    },
});
